// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeEmailChangeRequestBody = {
  newEmail: string;
  recaptchaToken?: string | null;
};

export type typeEmailChangeRequestOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    requestId: string;
    expiresInSeconds: number;
    nextRequestAllowedAt: string;
  };
};

export type typeEmailChangeRequestOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeEmailChangeRequestOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeEmailChangeRequestOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaEmailChangeRequestBody = {
  type: "object",
  properties: {
    newEmail: { type: "string", maxLength: 3000, minLength: 1 },
    recaptchaToken: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
  },
  required: ["newEmail"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createEmailChangeRequest(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaEmailChangeRequestBody);
  }

  return async function postEmailChangeRequest(
    payload: typeEmailChangeRequestBody,
  ): Promise<
    typeEmailChangeRequestOutput200 | typeEmailChangeRequestOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postEmailChangeRequest" failed before calling the network. #396fa6b605b7`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#396fa6b605b7" },
        },
        data: null,
      } as typeEmailChangeRequestOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/email/change-request`,
      httpMethod: "POST",
      options,
    })) as typeEmailChangeRequestOutput200 | typeEmailChangeRequestOutput400;
  };
}
